import { MyTooltip } from "../common/MyTooltip";

export const ExistsInCollectionTooltip = ({
  resourceSource = "FILE",
}: {
  resourceSource?: "FILE" | "LINK";
}) => {
  let message = "";

  message =
    "A resource with this name already exists, if you proceed the content may be duplicated.";

  return (
    <MyTooltip
      title={
        <>
          <span
            style={{
              color: "var(--text-color-primary",
            }}>
            {message}
          </span>
        </>
      }>
      <img
        src={"/icons/red-exclaim.svg"}
        onClick={() => {}}
        // style={{
        //   outline: fu.selected
        //     ? "2px solid var(--unseen-badge-color)"
        //     : "1px solid var(--container-border-color)",
        // }}
        className="file-exclaim"
        alt=""
      />
    </MyTooltip>
  );
};
